// extracted by mini-css-extract-plugin
module.exports = {"container":"UserPropertiesFilter_container__2k4U7","deleteIcon":"UserPropertiesFilter_deleteIcon__2gQiD"};